module.exports = __webpack_public_path__ + "static/media/slider-home-onepage-slide-01-image-01.300786e8.png";